import type {ExampleData, DataCallbackOptions} from '../../Common';
import {addPerspectiveCameraOBJWithOrbitControls} from '../../ExampleUtils';

export function createData(options: DataCallbackOptions): ExampleData {
	const {scene} = options;
	const root = scene.root();
	const geo = root.createNode('geo');

	const box = geo.createNode('box');
	const sphere = geo.createNode('sphere');
	box.p.size.set(1);
	box.p.divisions.set([10, 10, 10]);

	// use a normals SOP to have the normals pointing outwards like a sphere
	const normals = geo.createNode('normals');
	normals.setInput(0, box);
	normals.p.edit.set(true);
	normals.p.updateX.set(true);
	normals.p.updateY.set(true);
	normals.p.updateZ.set(true);
	normals.p.x.set('@P.x');
	normals.p.y.set('@P.y');
	normals.p.z.set('@P.z');

	// use a transform ray SOP to snap the points of the sphere to the box
	const ray = geo.createNode('ray');
	ray.setInput(0, normals);
	ray.setInput(1, sphere);

	// create a blend,
	// to blend between the sphere and its projected version
	const blend = geo.createNode('blend');
	blend.setInput(0, box);
	blend.setInput(1, ray);
	blend.flags.display.set(true);
	blend.uiData.setComment(
		`This node blends the box into a sphere.

		Try and change the blend parameter to see how this affects its output`
	);

	// add a light
	root.createNode('hemisphereLight');

	const {perspectiveCamera1} = addPerspectiveCameraOBJWithOrbitControls(root);

	return {
		scene,
		cameraPath: perspectiveCamera1.path(),
		focusedNodes: [blend],
		autoLayout: true,
	};
}

// export const sopBlend = [
// 	new Example({
// 		name: `${ExamplePrefix.BY_NODE}/sop/blend`,
// 		createData,
// 		relatedNodes: [BlendSopNode],
// 	}),
// ];
